import React, { useState, useMemo } from "react";
import faqsByType from "../data/faqs.json";

export default function Faq({ type = "panel", includeCommon = true }) {
  const [openIndex, setOpenIndex] = useState(0);

  const items = useMemo(() => {
    const byType = faqsByType[type] || [];
    const common = includeCommon ? (faqsByType.common || []) : [];
    return [...byType, ...common];
  }, [type, includeCommon]);

  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-green mb-12 text-center">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4">
          {items.map((faq, i) => {
            const open = openIndex === i;
            return (
              <div key={i} className="bg-white rounded-lg border border-brand-green shadow-sm">
                <button
                  onClick={() => setOpenIndex(open ? -1 : i)}
                  className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-green-50 rounded-lg focus:outline-none"
                  aria-expanded={open}
                  aria-controls={`faq-panel-${i}`}
                >
                  <span className="font-medium text-gray-800">{faq.q}</span>
                  <img
                    src={open ? "/down-arrow.png" : "/right-arrow.png"}
                    alt={open ? "Collapse" : "Expand"}
                    className="w-8 h-8 transform transition-transform duration-200"
                  />
                </button>

                <div
                  id={`faq-panel-${i}`}
                  className={`px-6 pb-4 text-gray-600 transition-[max-height] duration-300 ease-in-out ${open ? "max-h-40" : "max-h-0 overflow-hidden"
                    }`}
                >
                  {open && <p>{faq.a}</p>}
                </div>
              </div>
            );
          })}

          {items.length === 0 && (
            <div className="text-center text-gray-500">
              No FAQs added yet for “{type}”.
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
